// import Splide JS
import Splide from "@splidejs/splide";
// 拡張機能
import {AutoScroll} from "@splidejs/splide-extension-auto-scroll";

// デフォルトのテーマ
import "@splidejs/splide/css";


export default function initSplide() {


  // ==================================
  // トップページお知らせスライド
  // ==================================

  function _initTopicsSplide() {

    const topicsSplide = document.querySelector(".p-hm-topics__slider");

    if (!topicsSplide) return;
    
    const Topics = new Splide(".p-hm-topics__slider", {
      perPage: 6,
      perMove: 1,
      pagination: false,
      // padding: { right: 1660 },
      type:'slide',
      gap: "30px",

      breakpoints: {
        1020: {
          perPage: 1,
        },
      },
    });

    const bar = Topics.root.querySelector(".splide__progress-bar");

    // Splideの初期化が終わった際、またはスライドが切り替わる際にバーの長さを更新する
    Topics.on("mounted move", function () {
      const end = Topics.Components.Controller.getEnd() + 1;
      const rate = Math.min((Topics.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + "%";

      document.getElementById("p-hm-topics__pagination--current").textContent = Topics.index + 1;
    });

    Topics.mount();

    //スライド枚数取得
    function slideIndex() {
      // 現在のスライドが何枚目かを取得
      document.getElementById("p-hm-topics__pagination--current").textContent = Topics.index + 1;
      // スライドの総数を取得
      document.getElementById("p-hm-topics__pagination--length").textContent = Topics.length;
    }

    slideIndex();
  }

  _initTopicsSplide();

  // ==================================
  // リクルート　MVスライド
  // ==================================

  function _initRecruitMvSplide() {

    const recruitMvSplide = document.querySelector(".p-recruit-mv__slider");

    if (!recruitMvSplide) return;

    const RecruitMv = new Splide(".p-recruit-mv__slider", {
        perPage: 1,
        perMove: 1,
        pagination:false,
        arrows:false,
        autoplay: true,
        interval: 4000,
        type:"fade",
        rewind: true,
        speed:1500,
      } );
    
      RecruitMv.mount();
    
  }

  _initRecruitMvSplide();

  // ==================================
  // リクルート 仕事を紹介スライド
  // ==================================

  function _initRecruitJobSplide() {

    const recruitJobSplide = document.querySelector(".p-recruit-job__slider");

    if (!recruitJobSplide) return;

    const RecruitJob = new Splide(".p-recruit-job__slider", {
        type   : 'loop',
        drag   : 'free',
        focus  : 'center',
        arrows:false,
        pagination: false,
        gap:30,
        perPage: 4,

        autoScroll: {
          speed: 0.5,
          pauseOnHover: false,
          pauseOnFocus: false,
        },

        breakpoints: {
          1020: {
            perPage: 3,
            gap: 10,
          },

          560: {
            perPage: 2,
          },

        },

      } );
    
    RecruitJob.mount({AutoScroll});
    
  }

  _initRecruitJobSplide();

}

export { initSplide };
